/**
 * Created by shubham on 11/4/18.
 */

import {ApplicationsPage} from "./applications-page";

/**
 * An array of data with an associated page object used for paging
 */
export class ApplicationsPageData<T> {
    data = new Array<T>();
    page = new ApplicationsPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/applications-manager-dashboard/applications-datatable/applications-page-data.ts